import { useEffect } from 'react';

const SESSION_CHECK_INTERVAL = 60 * 1000; // 60 giây
let isShowingAlert = false;

function checkAndHandleExpiry() {
    const path = window.location.pathname;
    const isProtected = path.startsWith('/admin') || path.startsWith('/navo-admin');
    if (!isProtected) return; // Chỉ check trên trang protected

    const token = localStorage.getItem('token');
    if (!token) return; // Chưa đăng nhập, bỏ qua

    const expiresAt = localStorage.getItem('refreshTokenExpiresAt');
    if (!expiresAt) return; // Không có thông tin hết hạn, bỏ qua

    if (Date.now() > Number(expiresAt)) {
        if (isShowingAlert) return; // Tránh hiện nhiều alert
        isShowingAlert = true;

        // Xoá toàn bộ session
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        localStorage.removeItem('refreshTokenExpiresAt');
        localStorage.removeItem('expiry_banner_dismissed');

        const loginPath = path.startsWith('/navo-admin') ? '/navo-admin/login' : '/admin/login';

        alert('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.');
        isShowingAlert = false;
        window.location.href = loginPath;
    }
}

export default function useSessionCheck() {
    useEffect(() => {
        // Check ngay khi mount
        checkAndHandleExpiry();

        // Check mỗi 60 giây
        const interval = setInterval(checkAndHandleExpiry, SESSION_CHECK_INTERVAL);

        // Check khi tab trở lại active (giống AppState trên mobile)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkAndHandleExpiry();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
}
